module.exports = __webpack_public_path__ + "img/mes1.cb4106bd.png";